angular.module('skeyenoteWebApp').directive('numberWidget', InterpreterNumberDirective);

function InterpreterNumberDirective() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(function(inputValue) {
        let transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g, '') : null;
        if (transformedInput !== inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    },
  };
}
